import type { OrderMethodDetail } from '../../../services/vendors';

// livePurchaseOrders counts LIVE orders but deletion blocks on EVERY order, so
// a zero live count is not a promise. Only products are certain blockers.
export interface DeleteAffordance {
    /** False only when we KNOW it is blocked; otherwise the attempt is allowed. */
    enabled: boolean;
    /** Why it is blocked, or the caveat when the outcome is not knowable. */
    hint: string;
}

export function deleteMethodAffordance(
    method: Pick<OrderMethodDetail, 'references'>
): DeleteAffordance {
    const { linkedProducts, livePurchaseOrders } = method.references;

    if (linkedProducts > 0) {
        return {
            enabled: false,
            hint: `Reassign ${linkedProducts} product(s) first, or retire this method instead.`
        };
    }
    if (livePurchaseOrders > 0) {
        return {
            enabled: false,
            hint: `${livePurchaseOrders} live purchase order(s) reference it. Retire it instead.`
        };
    }
    return {
        enabled: true,
        hint: 'Only possible while nothing references it; past purchase orders block deletion too.'
    };
}
